import { useSelector } from 'react-redux';
import Module from '../../layout/Module';
import AlertSaveButton from '../../button/AlertSaveButton';
import { useState } from 'react';
import List from './List/List';
import FeedDialog from './Dialog/Dialog';
import FilterButtonFeed from './Filter/Filter';
import useFetchData from '../../../hooks/useFetchData';

const Feed = () => {
  const [modal, setModal] = useState(null);
  const permissions = useSelector((state) => state?.session?.permissions?.feed || {});
  const { isLoading: isLoadingRoles, data: dataRoles = [] } = useFetchData('roles/standard');

  return (
    <Module>
      <Module.Header title='Feed' titleLink={'/dashboard/feed'}>
        <div className='flex justify-end items-center gap-2'>
          {permissions?.created && (
            <AlertSaveButton
              submodule='Feed'
              icon='plus'
              title='Create'
              color='secondary'
              disabled={isLoadingRoles}
              onDontSave={() =>
                setModal({
                  type: 'create',
                  data: {
                    pusblishedAt: new Date().toISOString(),
                    expireAt: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString(),
                    minDays: 30,
                    title: '',
                    content: '',
                    viewRoles: isLoadingRoles ? [] : dataRoles
                  }
                })
              }
            />
          )}
        </div>
      </Module.Header>
      <Module.Body>
        <Module.BodyHeader className='border-b border-b-2 border-primary justify-between'>
          <FilterButtonFeed />
        </Module.BodyHeader>
        <Module.BodyContainer>
          <List onModal={(type, data) => setModal({ type, data })} />
        </Module.BodyContainer>
      </Module.Body>
      {modal && (
        <FeedDialog show={!!modal} type={modal.type} data={modal.data} onClose={() => setModal(null)} />
      )}
    </Module>
  );
};

export default Feed;
